
import { useRecoilValue } from 'recoil';
import { useState } from 'react';
import { Box, Button, Paper, Typography, Stepper, Step, StepLabel, StepContent } from '@mui/material';
import { userJourneyAtom } from '../../../Services/_states';

export default function UserJourney() {
  const userJourneyData = useRecoilValue(userJourneyAtom) || []; // Ensure it's an array
  const [numberShow, setNumberShow] = useState(5);

  const showHide = () => {
    if (userJourneyData.length === numberShow) setNumberShow(5);
    else setNumberShow(userJourneyData.length);
  };

  // Transform userJourneyData to the format needed by Stepper
  // const steps = userJourneyData
  //   .slice(0, numberShow)
  //   .map((item, index) => ({
  //     key: item?.id || `journey-step-${index}`, // Use a unique key if available, otherwise index
  //     label: `${item?.username || 'System'} ${item?.status || 'performed an action'}`,
  //     description: item?.timestamp
  //       ? new Date(item.timestamp).toLocaleString('en-GB', {
  //         year: 'numeric',
  //         month: 'short',
  //         day: '2-digit',
  //         hour: '2-digit',
  //         minute: '2-digit',
  //         second: '2-digit',
  //         hour12: true,
  //       })
  //       : 'No timestamp available',
  //   }));

  const steps = userJourneyData
    .slice(0, numberShow)
    .map((item, index) => ({
      key: item?.intervene_session_id || index,
      username: item?.username || 'System',
      status: item?.status,
      startTime: item?.timestamp,
      endTime: item?.session_closed_at || null,
    }));


  return (
    <Paper elevation={3} sx={{ p: 2, mb: 1, maxWidth: 500, }}>
      {/* <Typography variant="h6" gutterBottom>
        Customer Journey
      </Typography> */}
      {steps.length > 0 ? (
        <Stepper orientation="vertical">
          {steps.map((step) => (
            <Step key={step.key} active completed>
              <StepLabel>
                <Box>
                  <Typography variant="body2" fontWeight={600}>
                    {step.username} {step.status}
                  </Typography>

                  <Typography variant="caption" color="text.secondary">
                    Start Intervene ·{' '}
                    {step.startTime
                      ? new Date(step.startTime).toLocaleString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true,
                      })
                      : '—'}
                  </Typography>
                </Box>
              </StepLabel>

              {step.endTime && (
                <StepContent>
                  <Typography variant="caption" color="text.secondary">
                    End Intervene ·{' '}
                    {new Date(step.endTime).toLocaleString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true,
                    })}
                  </Typography>
                </StepContent>
              )}
            </Step>
          ))}
        </Stepper>

      ) : (
        <Typography sx={{ m: 2 }}>No journey data available.</Typography>
      )}
      {userJourneyData.length > 5 && (
        <Button
          variant="contained"
          onClick={showHide}
          sx={{ mt: 2, ml: 1 }} // Adjusted margin for alignment with stepper
        >
          {userJourneyData.length === numberShow ? 'Show Less' : 'Show More'}
        </Button>
      )}
    </Paper>
  );
}

// import { useRecoilValue } from 'recoil';
// import { useState } from 'react';
// import { Box, Button, Paper, Typography, Stepper, Step, StepLabel, StepContent } from '@mui/material';
// import { userJourneyAtom } from '../../../Services/_states';

// export default function UserJourney() {
//   const userJourneyData = useRecoilValue(userJourneyAtom) || []; // Ensure it's an array
//   const [numberShow, setNumberShow] = useState(5);

//   const showHide = () => {
//     if (userJourneyData.length === numberShow) setNumberShow(5);
//     else setNumberShow(userJourneyData.length);
//   };

//   // Transform userJourneyData to the format needed by Stepper
//   const steps = userJourneyData
//     .slice(0, numberShow)
//     .map((item, index) => ({
//       key: item?.id || `journey-step-${index}`, // Use a unique key if available, otherwise index
//       label: `${item?.username || 'System'} ${item?.status || 'performed an action'}`,
//       description: item?.timestamp ? new Date(item.timestamp).toLocaleString() : 'No timestamp available',
//     }));

//   return (
//     <Paper elevation={3} sx={{ p: 2, mb: 1, maxWidth: 500,}}>
//       {/* <Typography variant="h6" gutterBottom>
//         Customer Journey
//       </Typography> */}
//       {steps.length > 0 ? (
//         <Stepper orientation="vertical">
//           {steps?.map((step, index) => (
//             <Step key={step.key} active={true} completed={true}> {/* Mark all as active/completed for display */}
//               <StepLabel
//                 // Optional: if you want to show something like "Last event" for the last item
//                 // optional={
//                 //   index === steps.length - 1 && userJourneyData.length === numberShow ? (
//                 //     <Typography variant="caption">Latest</Typography>
//                 //   ) : null
//                 // }
//               >
//                 {step.label}
//               </StepLabel>
//               <StepContent> {/* StepContent is visible if its parent Step is active */}
//                 <Typography variant="body2" color="text.secondary">
//                   {step.description}
//                 </Typography>
//               </StepContent>
//             </Step>
//           ))}
//         </Stepper>
//       ) : (
//         <Typography sx={{m:2}}>No journey data available.</Typography>
//       )}
//       {userJourneyData.length > 5 && (
//         <Button
//           variant="contained"
//           onClick={showHide}
//           sx={{ mt: 2, ml: 1 }} // Adjusted margin for alignment with stepper
//         >
//           {userJourneyData.length === numberShow ? 'Show Less' : 'Show More'}
//         </Button>
//       )}
//     </Paper>
//   );
// }